import React, { Component } from 'react';
import { Row, Col, Panel, Button, Input } from 'react-bootstrap';
import { Translate } from 'react-redux-i18n';

import { ROOT_URL } from '../../../actions/root_url';

export class ScaleBarcodeModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      unitPrice: '',
      netWeight: '',
    };
  }

  render() {
    const { unitPrice, netWeight } = this.state;
    const { productNumber, selectedWarehouse, disable } = this.props;
    const url = productNumber && `${ROOT_URL}v1/warehouse/printbarcode/${productNumber}?warehouse_id=${selectedWarehouse && selectedWarehouse.value}&unit_price=${unitPrice}&net_weight=${netWeight}&Bearer=${localStorage.getItem('token')}`;
    
    return (
      <div>
        <Row>
          <Col xs={12} className="centerStyle">
            <label><Translate value="unit_price_$" /></label>
          </Col>
          <Col xs={12} className="centerStyle" style={{ marginTop: '5px', marginBottom: '10px' }}>
            <Input
              type="text"
              style={{ width: '250px' }}
              value={this.state.unitPrice }
              onChange={(e) => this.setState({ unitPrice: e.target.value })}
            />
          </Col>
          
          <Col xs={12} className="centerStyle">
            <label><Translate value="net_weight" /></label>
          </Col>
          <Col xs={12} className="centerStyle" style={{ marginTop: '5px', marginBottom: '10px' }}>
            <Input
              type="text"
              style={{ width: '250px' }}
              value={this.state.netWeight}
              onChange={(e) => this.setState({ netWeight: e.target.value })}
            />
          </Col>
          
          <Col xs={12} className="centerStyle">
            <Button
              type="button"
              bsStyle="primary"
              className="textAlignStyle"
              href={url}
              disabled={disable || unitPrice==='' || netWeight===''}
            >
              <Translate value="print" />
            </Button>
            <Button
              type="button"
              bsStyle="danger"
              className="textAlignStyle"
              onClick={() => {this.props.onCancel();}}
            >
              <Translate value="cancel" />
            </Button>
          </Col>
        </Row>
      </div>
    );
  }
}

export default ScaleBarcodeModal;



// WEBPACK FOOTER //
// ./master/jsx/components/Products/components/ScaleBarcodeModal.jsx